const heroTags = ["#综艺名场面", "#宝藏好剧", "#年度高赞", "#吃瓜自由"];

const stats = [
  { value: "1.2w+", label: "聚合精选内容" },
  { value: "380w+", label: "累计互动量" },
  { value: "每日", label: "热榜更新" },
];

export default function Hero() {
  return (
    <section id="hero" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=summer%20melon%20field%20sunset%20sky%20in%20warm%20orange%20and%20pink%20tones%2C%20abstract%20soft%20gradient%20backdrop%20with%20watermelon%20slices%20in%20gentle%20blur%20foreground%2C%20playful%20fresh%20summer%20vibe%2C%20magazine%20editorial%20background%2C%20vibrant%20but%20soft%20palette&width=1800&height=1000&seq=gua-hero-bg-01&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-background-50"></div>

      <div className="relative mx-auto flex max-w-6xl flex-col items-center px-4 pb-16 pt-28 md:pb-24 md:pt-40 text-center">
        <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/90 px-4 py-1.5 text-xs font-medium tracking-widest text-primary-700">
          <i className="ri-flashlight-line"></i>
          全网精华内容 · 每日精选合集
        </span>

        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
          今天值得吃的瓜
          <span className="block text-accent-200">都在这一份合辑里</span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/95 md:text-base">
          吃瓜大全替你翻遍综艺现场、宝藏好剧、音乐名场面与网络热议，
          只把高赞精华帖与热门推荐打包成册，让你用更短的时间，吃到更甜的瓜。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#trending"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 shadow-soft hover:bg-primary-600 transition-colors"
          >
            看今日热榜
            <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="#collection"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/95 px-7 py-3 text-sm font-semibold text-primary-700 hover:bg-background-100 transition-colors"
          >
            逛主题精选
            <i className="ri-compass-3-line"></i>
          </a>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {heroTags.map((tag) => (
            <span
              key={tag}
              className="whitespace-nowrap rounded-full border border-background-50/40 px-3.5 py-1 text-xs text-background-100"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-12 grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
          {stats.map((s) => (
            <div key={s.label} className="rounded-2xl bg-background-50/90 px-6 py-5 text-center backdrop-blur">
              <div className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">{s.value}</div>
              <div className="mt-1 text-xs text-foreground-600">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}